import './../../assets/css/App.css';
import './../../assets/css/layout.css';
import './../../assets/css/global/components.css';
import React, { Component } from 'react';
import PageTitle from './../../component/pageTitle'
import DashboardMetricTableView from './dashboardMetricTableView'
import DashboardInfoTableView from './dashboardInfoTableView'

class Dashboard extends Component {

    render() {
        return (
            <div className="page-content-wrapper">
                <PageTitle pageTitle = {"Dashboard Metrics"} ></PageTitle>
                <div className="page-content tabbable-custom column-xs-12">
                    <DashboardMetricTableView></DashboardMetricTableView>
                    <DashboardInfoTableView></DashboardInfoTableView>
                </div>
            </div>
        );
    }
}

export default Dashboard;
